<div class="pt-5">

  <!-- MAIN COLUMN -->
  <div class="px-3 2xl:px-6">

    <article class="w-full bg-white">

      <!-- TOP PAGINATION -->
      <div class="px-4 pt-4 sm:px-6 2xl:px-8">
        <div class="flex items-center justify-end rounded-2xl bg-white/95 p-4 backdrop-blur">
          <div class="w-fit overflow-hidden rounded-xl bg-white">
            <mat-paginator
              [length]="totalItems"
              [pageSize]="pageSize"
              [pageSizeOptions]="[pageSize]"
              showFirstLastButtons
              (page)="onPageChange($event)">
            </mat-paginator>
          </div>
        </div>
      </div>

      <!-- TABLE SECTION -->
      <div class="px-4 py-4 sm:px-6 2xl:px-8 2xl:py-6">
        <div class="overflow-hidden rounded-2xl bg-white">
          <div class="w-full overflow-x-auto">

            <mat-table
              [dataSource]="dataSource"
              matSort
              class="table-alternate !inline-table !w-full min-w-[1100px]">

              <!-- ID -->
              <ng-container matColumnDef="ID">
                <th mat-header-cell *matHeaderCellDef>
                  ID
                </th>

                <td mat-cell *matCellDef="let element">
                  <span class="font-medium text-gray-700">
                    {{ element.posting_queue_id }}
                  </span>
                </td>
              </ng-container>

              <!-- Story Article URL -->
              <ng-container matColumnDef="Story Article Url">
                <th mat-header-cell *matHeaderCellDef class="text-nowrap">
                  Url
                </th>

                <td mat-cell *matCellDef="let element">
                  <div class="flex max-w-[350px] items-center gap-2">

                    <span class="block max-w-[220px] truncate text-gray-800">
                      {{ element.rss_article_url }}
                    </span>

                    <button
                      mat-icon-button
                      [cdkCopyToClipboard]="element.rss_article_url"
                      (click)="onCopy(element.rss_article_url)"
                      matTooltip="Copy URL"
                      aria-label="Copy URL">
                      <mat-icon class="cursor-pointer text-gray-500 transition-colors duration-200 hover:text-gray-900">
                        content_copy
                      </mat-icon>
                    </button>

                  </div>
                </td>
              </ng-container>

              <!-- Story -->
              <ng-container matColumnDef="Story">
                <th mat-header-cell *matHeaderCellDef>
                  Story
                </th>

                <td mat-cell *matCellDef="let element" class="story-cell">
                  <div class="flex items-center">

                    <ng-container *ngIf="isVideoStory(element.tag)">
                      <video
                        *ngIf="element.createomate_video_url"
                        [src]="element.createomate_video_url"
                        controls
                        class="h-16 w-auto rounded-lg border border-gray-300 object-contain">
                      </video>
                    </ng-container>

                    <ng-container *ngIf="isImageStory(element.tag)">
                      <img
                        *ngIf="element.switchboard_storage_img"
                        [src]="element.switchboard_storage_img"
                        alt="Image Story"
                        class="h-16 w-auto rounded-lg border border-gray-300 object-contain" />
                    </ng-container>

                  </div>
                </td>
              </ng-container>

              <!-- Publication Platform -->
              <ng-container matColumnDef="Publication Platform">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Publication Platform
                </th>

                <td mat-cell *matCellDef="let element">
                  <ng-container *ngIf="element.platform?.toLowerCase() !== 'tiktok'; else tiktokNotice">
                    <div class="flex items-center gap-2">

                      <a
                        href="https://business.facebook.com/latest/story_composer/?asset_id=125340620853071&business_id=127715351554035&ref=biz_web_home_stories&context_ref=HOME"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="font-medium text-blue-600 underline underline-offset-2 transition-colors duration-200 hover:text-blue-800">
                        Social Platform
                      </a>

                      <mat-icon
                        *ngIf="element.platform?.toLowerCase() === 'facebook'"
                        class="!text-gray-500">
                        facebook
                      </mat-icon>

                      <mat-icon
                        *ngIf="element.platform?.toLowerCase() === 'instagram'"
                        class="!text-gray-500">
                        photo_camera
                      </mat-icon>

                      <mat-icon
                        *ngIf="element.platform?.toLowerCase() === 'tiktok'"
                        class="!text-gray-500">
                        music_note
                      </mat-icon>

                    </div>
                  </ng-container>

                  <ng-template #tiktokNotice>
                    <div class="flex max-w-md items-center gap-2 text-sm italic text-gray-400">
                      <span>
                        Sorry, TikTok does not support story posting from desktop.
                      </span>

                      <mat-icon class="text-gray-400">
                        music_note
                      </mat-icon>
                    </div>
                  </ng-template>
                </td>
              </ng-container>

              <!-- Created At -->
              <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef>
                  Created At
                </th>

                <td mat-cell *matCellDef="let element">
                  <span class="whitespace-nowrap text-gray-700">
                    {{ element.created_at | date:'dd/MM/yyyy HH:mm' }}
                  </span>
                </td>
              </ng-container>

              <!-- Published Story -->
              <ng-container matColumnDef="Published Story">
                <th mat-header-cell *matHeaderCellDef>
                  Published
                </th>

                <td mat-cell *matCellDef="let element">
                  <mat-checkbox
                    [checked]="element.is_story_published === 1"
                    (change)="onPublishedStatusChange(element, $event.checked)">
                  </mat-checkbox>
                </td>
              </ng-container>

              <!-- Header and Row Definitions -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

              <tr
                mat-row
                *matRowDef="let row; let i = index; columns: displayedColumns;"
                class="transition-colors duration-150 hover:bg-gray-50">
              </tr>

            </mat-table>

          </div>
        </div>
      </div>

      <!-- BOTTOM PAGINATION -->
      <div class="px-4 pb-4 sm:px-6 2xl:px-8">
        <div class="flex items-center justify-end rounded-2xl bg-white/95 p-4 backdrop-blur">
          <div class="w-fit overflow-hidden rounded-xl bg-white">
            <mat-paginator
              [length]="totalItems"
              [pageSize]="pageSize"
              [pageSizeOptions]="[pageSize]"
              showFirstLastButtons
              (page)="onPageChange($event)">
            </mat-paginator>
          </div>
        </div>
      </div>

    </article>

  </div>

</div>